import { render } from "./OTPVerificationModal.vue?vue&type=template&id=de8475ba&scoped=true"
import script from "./OTPVerificationModal.vue?vue&type=script&lang=js"
export * from "./OTPVerificationModal.vue?vue&type=script&lang=js"

import "./OTPVerificationModal.vue?vue&type=style&index=0&id=de8475ba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de8475ba"]])

export default __exports__